import * as React from 'react';
import { SVGProps } from 'react';

const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6h3l-5 6 5 6h-3l-5-6 5-6z" />
  </svg>
);

export default SvgChevronLeft;
